import React from "react";
import { Link } from "react-router-dom";

const about = ({
  hclass,
  title,
  subtitle,
  image,
  paragraphs,
  extraSections = [],
  showButton = true,
  onCount,
}) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className={hclass}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-12">
            <div className="about_left">
              <div className="image">
                <img src={image} alt={title} />
                <span className="round-on"></span>
                <span className="round-two"></span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="content">
              <h2>
                  {title}
              </h2>
              <h3>
                  {subtitle}
              </h3>

              {paragraphs &&
                paragraphs.map((p, i) => (
                  <p key={i}>
                      {p}
                  </p>
                ))}

              {showButton && (
                <Link className="theme-btn" onClick={ClickHandler} to="/about">
                  More About SKIEN
                </Link>
              )}
            </div>
          </div>
        </div>

        {/* Extra SEO Sections */}
        {extraSections.length > 0 && (
          <div className="row mt-5">
            <div className="col-12">
              {extraSections.map((section, index) => (
                <div key={index} className="about-extra-section mb-4">
                  <h3>{section.heading}</h3>
                  <p>{section.content}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default about;
